<a class="fc-brand-col" [FCRouterLink]="getUrl(brand)" [id]="'fc-brand-' + brand.id" [attr.aria-label]="brand.title + ' Products List'">
    <div>
        <img  class="img-responsive" loading="lazy" [src]="brand.imageSrc" [alt]="getAltText(brand)"> 
    </div>
    <h3>{{brand.title}}</h3>
</a> 